import type { FormValues } from './';

export default (values: FormValues) => {
  const validationErrors = {};

  if (!values.title) {
    validationErrors.title = 'Request title cannot be blank';
  }

  if (typeof values.date !== 'number' || values.date <= 0 || isNaN(values.date)) {
    validationErrors.date = 'A date must be specified';
  }

  if (
    typeof values.requestType !== 'number' ||
    values.requestType <= 0 ||
    isNaN(values.requestType)
  ) {
    validationErrors.requestType = 'A request type must be selected';
  }

  if (!values.trackTitle) {
    validationErrors.trackTitle = 'Track title cannot be blank';
  }

  if (!values.trackPerformers) {
    validationErrors.trackPerformers = 'Track performers cannot be blank';
  }

  if (!values.trackAuthors) {
    validationErrors.trackAuthors = 'Track authors cannot be blank';
  }

  if (!values.quotationTitle) {
    validationErrors.quotationTitle = 'Quotation title cannot be blank';
  }

  if (!values.smartlistTitle) {
    validationErrors.smartlistTitle = 'Smartlist title cannot be blank';
  }

  return validationErrors;
};
